import request from '@/utils/request'

/**
 * 查询所有轮播图列表信息
 */
export const findSlideAll = () => {
    return request({
        url: '/slide',
        method: 'get',
    })
}

/**
 * 查询站点信息
 */
export const findSite = () => {
    return request({
        url: '/site',
        method: 'get',
    })
}

/**
 * 查询八条最新 新闻要闻
 */
export const findNewsImportant = () => {
    return request({
        url: '/posts/newsimportant',
        method: 'get',
    })
}

/**
 * 查询主分类期刊出版下的子分类
 */
export const findCategoryPeriodical = () => {
    return request({
        url: '/category/periodical',
        method: 'get',
    })
}


/**
 * 查询期刊出版分类下的文章信息
 */
export const findPeriodical = () => {
    return request({
        url: '/posts/periodical',
        method: 'get',
    })
}

/**
 * 查询党的建设下的文章
 */
export const findParty = () => {
    return request({
        url: '/posts/party',
        method: 'get',
    })
}

/**
 * 查询新闻信息
 * @param {*} id 
 */
export const findPosts = (id) => {
    return request({
        url: `/posts/${id}`,
        method: 'get',
    })
}

/**
 * 查询主分类通知公告下的子分类
 */
export const findCategoryInform = () => {
    return request({
        url: '/category/inform',
        method: 'get',
    })
}

/**
 * 根据分类id查询新闻分页
 * @param {*} pageCode 
 * @param {*} pageSize 
 * @param {*} categoryId 
 */
export const findPostsPageByCategoryId = (pageCode, pageSize, categoryId) => {
    return request({
        url: '/posts/category',
        method: 'get',
        params: {
            pageCode,
            pageSize,
            categoryId
        }
    })
}

/**
 * 查询关于我们分类下文章
 */
export const findAboutus = () => {
    return request({
        url: '/posts/aboutus',
        method: 'get',
    })
}


/**
 * 搜索文章
 */
export const findSearch = (keyword) => {
    return request({
        url: '/posts/search',
        method: 'get',
        params: {
            keyword
        }
    })
}

/**
 * 查询研究咨询分类下文章
 */
export const findResearch = () => {
    return request({
        url: '/posts/research',
        method: 'get'
    })
}

/**
 * 查询全部友链信息
 */
export const findLinksAll = () => {
    return request({
        url: '/links',
        method: 'get',
    })
}

export const findPostsListByCategoryId = (categoryId) => {
    return request({
        url: '/posts/list',
        method: 'get',
        params: {
            categoryId
        }
    })
}





// WEBPACK FOOTER //
// ./src/api/front.js